import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetPigmentDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/pigment/${id}`);
}

export function apiGetAllPigments(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/pigments`);
}

export function apiCreateOrUpdatePigment(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/pigmentcreateorupdate`, data);
}

export function apiDeletePigment(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/pigment/${id}`);
}
